import React from 'react';
import { RatesRequirementsPanel, KindPanel } from './AdminDataOpsPage';

/**
 * Procurement-only page: mirrors the admin Rates upload flow (rules + template +
 * preview + publish) but nothing else. Route is guarded by ProcurementRoute
 * in App.js — only role='procurement' or role='admin' can reach it.
 */
export default function ProcurementRatesPage() {
  return (
    <div className="p-6 space-y-6" data-testid="procurement-rates-page">
      <div>
        <h1 className="text-2xl font-semibold text-dash-ink">Daily Rates Upload</h1>
        <p className="text-sm text-dash-mut mt-1">
          Add today's raw-material rates. Preview the parse result, then publish — the Price Trend
          dashboard picks up the new rows automatically within 20 seconds.
        </p>
      </div>
      <RatesRequirementsPanel />
      <KindPanel kind="rates" onStagingChange={() => {}} />
    </div>
  );
}
